import * as React from 'react';
import { Deferred } from '@fluidx/utilities';
/**
 * A react hook that keeps track of when the effect should be cancelled/cleaned up and exposes that to the caller
 * through a cancel Promise
 * @param callback Callback that performs the effect. Takes a cancel Promise and should disable all its side effects (e.g. calling setState) when that promise resolves
 * @param deps deps to be passed into React.useEffect
 */ export function useCancellableEffect(callback, deps) {
    const cancelToken = new Deferred();
    React.useEffect(()=>{
        const cleanup = callback(cancelToken);
        return ()=>{
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            cleanup && cleanup();
            cancelToken.resolve('CANCELLED');
        };
    // Mirror the useEffect API and only update the effect when deps change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
